import React from 'react'
import PropTypes from 'prop-types'
import { trackGtmEvent } from '../../util/tracking'
import Slider from './Slider'
import Modal from './Modal'
import './styles.scss'

class ImageCtnSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = { currentIndex: 0, showModal: false }

    this.slider = React.createRef()
    this.handleChange = this.handleChange.bind(this)

    this.wrapperRef = React.createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.closeButton = this.closeButton.bind(this)
    this.handleModalButtonClick = this.handleModalButtonClick.bind(this)
  }

  handleChange(currentIndex) {
    this.setState({ currentIndex })
  }

  /* MODAL */
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside(e) {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(e.target)
    ) {
      this.closeModal()
    }
  }

  closeModal() {
    if (this.state.showModal) {
      this.setState({ showModal: false })
    }
  }

  closeButton() {
    return <i onClick={this.closeModal} className="icon ion-close" />
  }

  handleModalButtonClick() {
    const { withModalContent, slides } = this.props
    const { currentIndex } = this.state
    if (withModalContent) {
      this.setState({ showModal: true })
    }

    if (window.location.pathname === '/bestellen/korona-kasse/') {
      trackGtmEvent('llplus_korona_eventTracking', {
        llplus_interaction: 'show-details',
        llplus_functionality: slides[currentIndex].title,
      })
    }
  }

  /* MODAL END */

  render() {
    const {
      size,
      type,
      showlink,
      title,
      text,
      withModalContent,
      slides,
      isMD,
    } = this.props
    const { currentIndex, showModal } = this.state
    //console.log('props', this.props) // eslint-disable-line

    return (
      <div
        className={`dhsv_image_ctn_slider ${size} block-${type}`}
        ref={this.wrapperRef}
      >
        {(title || text) && (
          <div className="row block-training__top">
            {title && (
              <div className="col-md-12 col-lg-4">
                <h2
                  className="dhsv_image_ctn_slider__title"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </div>
            )}
            {text && (
              <div className="col-md-12 col-lg-8">
                <p
                  className="dhsv_image_ctn_slider__text"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              </div>
            )}
          </div>
        )}
        <div className="row">
          <div className={`${type == 'training' ? 'col-lg-8' : 'col'}`}>
            <div className="slider-wrapper">
              <Slider
                size={size}
                showlink={showlink}
                withModalContent={withModalContent}
                slides={slides}
                handleChange={this.handleChange}
                handleModalButtonClick={this.handleModalButtonClick}
                ref={slider => {
                  this.slider = slider
                }}
              />
            </div>
          </div>
          {!isMD && (
            <div
              className={`${
                type == 'training' ? 'col-lg-4' : 'col-auto'
              } listcon`}
            >
              <ul>
                {slides.map((slide, i) => (
                  <li
                    onClick={() => {
                      this.slider.flkty.select(i)
                    }}
                    key={i}
                    className={currentIndex === i ? 'active' : ''}
                  >
                    {slide.shortTitle ? slide.shortTitle : slide.title}
                  </li>
                ))}
              </ul>
              <div className="flickity-arrows">
                <div
                  className={`flickity-arrow -left ${
                    currentIndex === 0 ? '-disabled' : ''
                  }`}
                  onClick={() => {
                    this.slider.flkty.previous()
                  }}
                />
                <div
                  className={`flickity-arrow -right ${
                    currentIndex === slides.length - 1 ? '-disabled' : ''
                  }`}
                  onClick={() => {
                    this.slider.flkty.next()
                  }}
                />
              </div>
            </div>
          )}
        </div>
        {showModal && (
          <Modal
            ref={this.wrapperRef}
            data={slides[currentIndex]}
            closeButton={this.closeButton}
          />
        )}
      </div>
    )
  }
}

ImageCtnSlider.propTypes = {
  isMD: PropTypes.bool,
  type: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  showlink: PropTypes.bool.isRequired,
  withModalContent: PropTypes.bool.isRequired,
  slides: PropTypes.array.isRequired,
}

export default ImageCtnSlider
